import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { ListadoOperacionesEstadoComponent } from './listado-operaciones-estado/listado-operaciones-estado.component';
import { SecurityService } from 'app/services/security/security.service';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-rep-finanzas',
  templateUrl: './rep-finanzas.component.html',
  styleUrls: ['./rep-finanzas.component.scss'],
  providers: [DatePipe, ListadoOperacionesEstadoComponent, MessagesTitles, MessagesGeneral, MessagesStatus]
})
export class RepFinanzasComponent {

  constructor(private loginService: LoginService,
    private carga: ListadoOperacionesEstadoComponent, private securityService: SecurityService) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }
  ExportTOExcel() {
    let fecha = new Date();
    const headerStyle: any = this.securityService.headerStyle;
    const data = this.securityService.dataBuffer;
    const footer = this.securityService.footerStyle;
    const headers = this.securityService.displayedColumns;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('My Sheet');
    const headersString: any = [];

    headers.forEach(element => {
      headersString.push(element.split("_").join(' '));
    });

    var i = 0;
    headerStyle.forEach((element, index) => {
      if (element.cells) {
        worksheet.mergeCells(String(element.cells));
      }
      if (element.title) {
        worksheet.getCell(element.cell).value = element.title;
      } else {
        worksheet.getCell(element.cell).value = headersString[i];
        i++;
      }
      worksheet.getColumn(index + 1).width = 20;
      worksheet.getCell(element.cell).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      worksheet.getCell(element.cell).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: element.fgColor }
      };
      worksheet.getCell(element.cell).font = {
        name: 'Arial',
        color: { argb: element.color },
        bold: true,
        size: 11
      }
      worksheet.getCell(element.cell).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

      // Add data
      let count=3;
      data.forEach((item,index) => {
        const rows=worksheet.getRow(count);
        headers.forEach((header,ind) => {
          if(String(item[header]).includes('.')){
            if(
              String(item[header]).includes('.pe') ||
              String(item[header]).includes('.com') ||
              String(item[header]).includes('E.I.R.L') ||
              String(item[header]).includes('S.A.C') ||
              String(item[header]).includes('S.R.L') ||
              String(item[header]).includes('S.A') ||
              String(item[header]).includes('S.C.R.L') ||
              String(item[header]).includes('@')
            ){
              rows.getCell(ind+1).value=item[header];
            }else{
              rows.getCell(ind+1).value=Number(item[header]);
            }
        }else{
          rows.getCell(ind+1).value=item[header];
        }
        rows.getCell(ind + 1).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
      count++;
    });
    //Add Footer
    footer.forEach((item, index) => {
      const rows = worksheet.getRow(data.length + 3);
      rows.getCell(index + 4).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: item.fgColor }
      };
      rows.getCell(index + 4).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
      if (item.content) {
        rows.getCell(index + 4).value = item.content;
      }
      if (item.formula && data.length > 0) {
        rows.getCell(index + 4).value = { formula: `${item.formula}(${item.col}3:${item.col}${data.length + 2})`, date1904: false };
      }
      rows.getCell(index + 4).alignment = { vertical: 'middle', horizontal: 'center' };
      rows.getCell(index + 4).font = {
        name: 'Arial',
        color: { argb: item.color },
        bold: true,
        size: 11
      }
    });

    // Generate Excel file
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Reporte_Finanzas_' + fecha + '.xlsx');
    });


  }
  
}
